import React, { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import DialogConfirmCancel from '../../../../dialog/DialogConfirm';
import useSubjects from '../../../../../hooks/subjects/useSubjects';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import FormCurriculum from '../Form/FormCurriculum';

const DialogAction = ({ show, onClose, type, formData = {}, onReset }) => {
  const types = ['archive', 'delete', 'clone', 'batch-delete', 'update-curriculum-elements'];
  const { curriculumId } = useParams();
  const navigate = useNavigate();

  const [loading, toggleLoading] = useState(false);
  const [errors, setInputErrors] = useState({});
  const [form, setInputForm] = useState(formData);
  const {
    deleteSubject,
    archiveSubject,
    cloneSubject,
    batchDeleteSubjects,
    batchUpdateSubjectsCurriculumElements
  } = useSubjects();

  const onConfirm = async (e) => {
    if (!types.includes(type)) {
      setInputErrors({ message: 'Invalid type' });
      return;
    }
    if (form._id === undefined) {
      setInputErrors({ message: 'Invalid id' });
      return;
    }
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = { error: false };
      if (type === 'delete') {
        result = await deleteSubject(form._id);
      }
      if (type === 'archive') {
        result = await archiveSubject(form._id);
      }
      if (type === 'clone') {
        result = await cloneSubject(form._id, form.email);
      }
      if (type === 'batch-delete') {
        result = await batchDeleteSubjects(form._id);
      }
      if (type === 'update-curriculum-elements') {
        result = await batchUpdateSubjectsCurriculumElements(form._id, form);
      }
      if (result.error) {
        setInputErrors(result);
      } else {
        if (type === 'delete' || type === 'archive') {
          navigate(`/dashboard/subjects/${curriculumId}`);
        }
        onReset();
        onClose();
      }
    } finally {
      toggleLoading(false);
    }
  };

  useEffect(() => {
    setInputForm(formData);
    if (!formData._id) {
      setInputErrors({ message: 'Invalid id' });
    }
  }, [formData]);

  const onChangeForm = (name, value) => {
    setInputForm({
      ...form,
      [name]: value
    });
  }

  return (
    <DialogConfirmCancel
      id={`subjects-${type}-dialog`}
      open={show}
      onCancel={onClose}
      onConfirm={types.includes(type) && form._id ? onConfirm : undefined}
      loading={loading}
      title={
        type
          .split('-')
          .join(' ')
          .replace(/\b\w/g, (l) => l.toUpperCase()) + ' Subject'
      }
      onCloseHeader={true}
      maxWidth='xs'
    >
      {['update-curriculum-elements'].includes(type) ? (
        <Grid container spacing={2}>
          <FormCurriculum
            formData={form}
            form={form}
            errorData={errors || {}}
            onChange={onChangeForm}
            onChangeAlert={onChangeForm}
            showHeader={false}
          />
        </Grid>
      ) : (
        <Box>
          {['batch-delete'].includes(type) ? (
            <Typography component={'div'}>
              Are you sure you want to {type.replace('-', ' ')} the subjects?
            </Typography>
          ) : (
            <Typography component={'div'}>
              Are you sure you want to {type} the subject: <b>{form?.name}</b>?
            </Typography>
          )}
        </Box>
      )}

      {errors?.message && <Alert severity='error'>{errors?.message}</Alert>}
    </DialogConfirmCancel>
  );
};

export default DialogAction;
